require('@fancyapps/fancybox');



// WEBPACK FOOTER //
// ./js/modules/_fancybox.js